
<div class="row">
    <button (click)="testMailFunction()" class="link nav-link"> Test Mail</button>
    </div>

<div class="row">
  <table  datatable [dtOptions]="dtOptions" class="table table-striped display compact">
    <thead>
      <tr><th></th></tr>
    </thead>
    <tbody>
    <tr class="col-sm-3" *ngFor="let item of managementItems">
        <td><a [routerLink]="item[1]">{{item[0]}}</a></td>
    </tr>
  </tbody>
  </table>
</div>




